import { Inject, Injectable } from '@angular/core';
import { PacsViewerInfo } from 'src/app/model/pacs/pacs-viewer-info';
import { AuthService } from '../auth.service';
import { DataService } from '../data.service';
import * as CryptoJS from 'crypto-js';
import { EnvironmentPresetService } from '../environment-preset/environment-preset.service';

export abstract class PacsService {
    abstract pacsViewerInfo(studyReportId: number, accessionNumber: string): Promise<string>;
}

export class PacsDefaultService {
    private readonly pacsViewerInfoEndPoint: string = '/studyReport/pacsViewerInfo/';

    constructor(private dataService: DataService) {

    }

    public async pacsViewerInfo(studyReportId: number, accessionNumber: string): Promise<string> {
        const params = { StudyReportId: studyReportId, AccessionNumber: accessionNumber };
        const info = await this.dataService.post<PacsViewerInfo>(this.pacsViewerInfoEndPoint, params).toPromise();
        return info.Url;
    }
}

export class PacsPixeonService {

    private readonly pacsViewerInfoEndPoint: string = '/studyReport/pacsViewerInfo/';

      constructor(
        private dataService: DataService,
        private auth: AuthService,
        private environmentPresetService: EnvironmentPresetService,
        private baseUrl: string) { }

    async pacsViewerInfo(studyReportId: number, accessionNumber: string): Promise<string> {

        const startLocalClient = this.environmentPresetService.getPreset().startLocalPacsClient;

        const params = {
          InternalNet: this.baseUrl.includes(this.auth.getInternalServerUrl()),
          StartLocalClient: startLocalClient,
          StudyReportId: studyReportId,
          AccessionNumber: accessionNumber,
          SectorId: this.auth.getSectorId(),
        };

        const info = await this.dataService.post<PacsViewerInfo>
            (this.pacsViewerInfoEndPoint, params).toPromise();

        if ( !info.Token || startLocalClient ) {
            return info.Url;
        } else {

            let payload = info.AccessionNumbers[0];
            let url = info.Url + '1?';
            url += 'a=' + info.AccessionNumbers[0];

            const date = new Date(info.Horario);
            let timestamp = date.getTime(); // epoch on MILIseconds
            timestamp = Math.round(timestamp / 1000); // epoch on seconds
            payload += timestamp;
            url += '&t=' + timestamp;

            const hash = CryptoJS.HmacSHA1(payload, info.Token);
            const hmac = hash.toString(CryptoJS.enc.Hex);

            url += '&h=' + hmac;
            url += '&lang=es&r=1';
            return url;
        }
    }
}

export function pacsServiceFactory(
    dataService: DataService,
    authService: AuthService,
    environmentPresetService: EnvironmentPresetService,
    baseUrl: string) {

    if ( authService.getPacsName() === 'Pixeon' ) {
        return new PacsPixeonService(
            dataService,
            authService,
            environmentPresetService,
            baseUrl);
    } else {
        return new PacsDefaultService(dataService);
    }
}
